import App from 'components/App';
import {
  LoginRequiredAccountsWeb, LogoutRequired,
  LoginRequiredMsWeb, ForceLogin, ClearStorage,
  LoginRequiredSubscriptions
} from 'components/RouteWrappers';
import {
  FocusedLayout, HeaderLayoutMs, HeaderLayoutCheckoutSuccess,
  HeaderAndSidebarLayout, HeaderLayout, HeaderLayoutSubscriptionActivate
} from 'views/Layout';
import DefaultAuth, { MsAuth } from 'views/OnBoard';
import SubscriptionActivate, { SubscriptionActivateSuccess } from 'views/SubscriptionActivate';
import PartnerActivate, { PartnerActivateSuccess } from 'views/ActivatePartner';
import Account from 'views/Account';
import DataPolicy from 'views/DataPolicy';
import CommunicationPreferences from 'views/CommunicationPreferences';
import Subscriptions from 'views/Subscriptions';
import { CheckoutSuccess, CheckoutSuccessMeditationStudio } from 'views/CheckoutSuccess';
import SignupSuccess from 'views/SignupSuccess';
import Default from 'views/Default';
import endPoints from './endpoints';

export default [
  {
    component: App,
    routes: [
      {
        component: ForceLogin, // route protector
        routes: [
          {
            path: endPoints.signin,
            component: LogoutRequired, // route protector
            exact: true,
            routes: [
              {
                component: FocusedLayout, // layout
                routes: [
                  {
                    component: DefaultAuth // view component
                  }
                ]
              },
            ],
          },
          {
            path: endPoints.msSignin,
            component: LogoutRequired, // route protector
            exact: true,
            routes: [
              {
                component: FocusedLayout, // layout
                routes: [
                  {
                    component: MsAuth // view component
                  }
                ]
              },
            ],
          },
          {
            path: endPoints.signupSuccess,
            component: LogoutRequired, // route protector
            exact: true,
            routes: [
              {
                component: HeaderLayout,
                routes: [
                  {
                    component: SignupSuccess, // view component
                  }
                ]
              }
            ]
          },
          {
            path: endPoints.redemptionActivate,
            component: HeaderLayoutSubscriptionActivate, // view Layout
            exact: true,
            routes: [
              {
                component: SubscriptionActivate // view component
              }
            ]
          },
          {
            path: endPoints.redemptionActivateSuccess,
            component: HeaderLayoutSubscriptionActivate, // view Layout
            exact: true,
            routes: [
              {
                component: SubscriptionActivateSuccess // view component
              }
            ]
          },
          {
            path: endPoints.activatePartner,
            component: ClearStorage, // route protector
            exact: true,
            routes: [
              {
                component: FocusedLayout, // layout
                routes: [
                  {
                    component: PartnerActivate // view component
                  }
                ]
              },
            ],
          },
          {
            path: endPoints.activatePartnerSuccess,
            exact: true,
            component: PartnerActivateSuccess // view component
          },
          {
            path: endPoints.checkoutSuccess,
            component: LoginRequiredAccountsWeb, // route protector
            exact: true,
            routes: [
              {
                component: HeaderLayoutCheckoutSuccess,
                routes: [
                  {
                    component: CheckoutSuccess // view component
                  }
                ]
              }
            ]
          },
          {
            path: endPoints.checkoutSuccessMeditationStudio,
            component: LoginRequiredMsWeb, // route protector
            exact: true,
            routes: [
              {
                component: HeaderLayoutMs,
                routes: [
                  {
                    component: CheckoutSuccessMeditationStudio // view component
                  }
                ]
              }
            ]
          },
          {
            path: endPoints.memberships,
            component: LoginRequiredSubscriptions, // route protector
            exact: true,
            routes: [
              {
                component: HeaderAndSidebarLayout, // view Layout
                routes: [
                  {
                    component: Subscriptions // view component
                  }
                ]
              }
            ]
          },
          {
            path: endPoints.default,
            component: LoginRequiredAccountsWeb, // route protector
            routes: [
              {
                component: HeaderAndSidebarLayout, // view Layout
                routes: [
                  {
                    path: endPoints.default,
                    exact: true,
                    component: Default// view component
                  },
                  {
                    path: endPoints.accountSetting,
                    exact: true,
                    component: Account // view component
                  },
                  {
                    path: endPoints.dataPolicy,
                    exact: true,
                    component: DataPolicy // view component
                  },
                  {
                    path: endPoints.subscriptions,
                    exact: true,
                    component: Subscriptions // view component
                  },
                  {
                    path: endPoints.communicationPreferences,
                    exact: true,
                    component: CommunicationPreferences // view component
                  }
                ]
              },
            ],
          },
        ],
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/config/routes/routes.js